import type { HTMLAttributes, ReactNode } from 'react';
import { DT } from '../../theme/designTokens';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  maxWidth?: number | false;
}

/**
 * Responsive page content wrapper.
 * max-width: 1596px, padding: clamp(24px, 8vw, 162px) per design spec.
 */
export function PageContent({ children, maxWidth, style, ...rest }: Props) {
  const mw = maxWidth === false ? undefined : (maxWidth ?? DT.layout.contentMaxWidth);

  return (
    <div
      style={{
        width:         '100%',
        maxWidth:      mw,
        margin:        '0 auto',
        paddingLeft:   DT.layout.contentPadding,
        paddingRight:  DT.layout.contentPadding,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
